/* @flow */
import produce from 'immer';
import { message } from 'antd';
import { actionTypes } from './actions';
import { defineServerErrors } from '@/utils/redux';

const {
  FETCH_AGREEMENTS,
  FETCH_SUCCESS,
  FETCH_FAILED,

  CREATE_AGREEMENT,
  CREATE_AGREEMENT_SUCCESS,
  CREATE_AGREEMENT_FAILED,

  TABLE_CHANGE,
} = actionTypes;

type State = {
  isFetching: boolean,
  tableOptions: TableT,
  data: AgreementT[],
  fetchErrors: Array<string>,
  isCreatingAgreement: boolean,
  createErrors: string[],
  agreementData: AgreementT,
};

const initialState = {
  isFetching: false,
  tableOptions: {
    page: 1,
    limit: 10,
    count: 0,
  },
  data: [],
  fetchErrors: [],
  isCreatingAgreement: false,
  createErrors: [],
  agreementData: {},
};

export default (state: State = initialState, action: ActionT = {}): State =>
  produce(state, (draft) => {
    // eslint-disable-next-line default-case
    switch (action.type) {
      case FETCH_AGREEMENTS:
        draft.isFetching = true;
        return;
      case FETCH_SUCCESS: {
        const { results, page, limit, count } = action.payload;
        draft.isFetching = false;
        draft.data = results;
        draft.fetchErrors = initialState.fetchErrors;
        draft.tableOptions = {
          page,
          limit,
          count,
        };
        return;
      }
      case FETCH_FAILED:
        draft.isFetching = false;
        draft.fetchErrors = defineServerErrors(action.payload, 'Some error has occurred. Please try again later.');
        draft.fetchErrors.forEach((error) => message.error(error, 10));
        return;
      case CREATE_AGREEMENT:
        draft.isCreatingAgreement = true;
        message.info('Agreement is sending. Please wait.', 5);
        return;
      case CREATE_AGREEMENT_SUCCESS:
        draft.isCreatingAgreement = false;
        draft.agreementData = action.payload;
        draft.createErrors = initialState.createErrors;
        message.success('Agreement sent successfully.');
        return;
      case CREATE_AGREEMENT_FAILED:
        draft.isCreatingAgreement = false;
        draft.createErrors = defineServerErrors(action.payload, 'Some error has occurred. Please try again later.');
        draft.createErrors.forEach((error) => message.error(error, 10));
        return;
      case TABLE_CHANGE:
        draft.tableOptions = action.payload;
        return;
    }
  });
